import { ApplicationConfiguration as ApplicationConfigurationModel } from '@rocksoft/mdm-sdk-v2';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

export interface ApplicationConfiguration extends ApplicationConfigurationModel {
  udid: string;
}

export type ApplicationConfigurationState = EntityState<ApplicationConfiguration>;

export function selectId(applicationConfiguration: ApplicationConfiguration): string {
  return `${applicationConfiguration.udid}-${applicationConfiguration.identifier}`;
}

export const adapter: EntityAdapter<ApplicationConfiguration> = createEntityAdapter<ApplicationConfiguration>({
  selectId,
});

export const initialState: ApplicationConfigurationState = adapter.getInitialState();
